(function () {
  'use strict';

  angular.module('ringbaPortal').component('newOfferBox', {
    bindings: {
      campaignId: '<',
      campaignCountry: '<',
      publishedOffer: '<',
      onCampaignOfferChange: '&'
    },
    controller: NewOfferBoxController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/offer/new-offer-box/new-offer-box.view.html'
  });

  function NewOfferBoxController(

  ) {
    'ngInject';

    const vm = this;

    vm.showNewForm = false;

    vm.showForm = showForm;
    vm.hideForm = hideForm;

    function showForm() {
      vm.showNewForm = true;
    }

    function hideForm() {
      vm.showNewForm = false;
    }

  }
})();
